import { render, staticRenderFns } from "./AmostrasStatusOutros.vue?vue&type=template&id=0b68cfa5&"
import script from "./AmostrasStatusOutros.vue?vue&type=script&lang=ts&"
export * from "./AmostrasStatusOutros.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports